import UserDataService from '../../../../Shared/Assets/userdata-service';
import EventBus, { EventName } from '../../../../Shared/Assets/event-bus';
import { empty, waitFor, onceOnly } from '../../../../Shared/Assets/utils';
import DealerAvailabilityRenderer from './dealer-availability-renderer';

export default class EnquiryForm {
  constructor(options) {
    this._handleSubmit = this._handleSubmit.bind(this);
    this._sendEnquiry = this._sendEnquiry.bind(this);
    this._initSearchQuery = this._initSearchQuery.bind(this);
    this._populateFraudNetInfo = this._populateFraudNetInfo.bind(this);
    this._hideInterstateConfirmationForm = this._hideInterstateConfirmationForm.bind(this);
    this._showInterstateConfirmationForm = this._showInterstateConfirmationForm.bind(this);
    this._handleEnquirySubmittedEvent = this._handleEnquirySubmittedEvent.bind(this);
    this._handleEventTriggerFraudnetReject = this._handleEventTriggerFraudnetReject.bind(this);
    this._handleFinanceEligibilityResponded = this._handleFinanceEligibilityResponded.bind(this);
    this._checkFinanceEligibility = this._checkFinanceEligibility.bind(this);

    this.eventBus = new EventBus();
  }

  init(formElement) {
    this.formElement = formElement;
    this.$form = $(formElement);
    this.body = $('html, body');
    this.$errorMessageBox = this.$form.find(".error-message-block");
    this.$submitButtons = this.$form.find("button[type='submit'],input[type='submit']");
    this.$form.on('submit', this._handleSubmit);
    this._initShowOnHover();
    this._initInterstateEnquiryConfirmationForm();
    this._initPostCodeInput();
    this._initSearchQuery();
    this._initEventListener();
    this._checkFinanceEligibility();
  }

  _initShowOnHover() {
    let divBlock = this.$form.find(".show-on-hover");
    if (divBlock.length == 0) return;
    divBlock.hide();
    this.$form.on('mouseover', () => {
      if (!divBlock.is(":visible")) {
        divBlock.slideDown();
        this.$form.off("mouseover");
      }
    });
  }

  _initInterstateEnquiryConfirmationForm() {
    if(!this.formElement.btnCancelInterstateEnquiry)
      return;
    this.hfInterstateEnquiryConfirmed = this.formElement.InterstateEnquiryConfirmed;
    this.interstateConfirmationForm = $(this.$form.find(".interstate-enquiry-confirmation"));
    this.mainEnquiryForm = $(this.$form.find(".main-enquiry-section"));
    this.formElement.btnCancelInterstateEnquiry.addEventListener('click', evt => {
      this._hideInterstateConfirmationForm();
      this.hfInterstateEnquiryConfirmed.value = "False";
    });
    this.formElement.btnConfirmInterstateEnquiry.addEventListener('click', evt => {
      this.hfInterstateEnquiryConfirmed.value = "True";
    });
  }

  _initPostCodeInput() {
    let formElement = this.formElement;
    let dealerAvailabilityReact = formElement.querySelector("[data-react-dealer-availability]");
    if (dealerAvailabilityReact) {
      let hasDealerAvailability = dealerAvailabilityReact.getAttribute("data-react-dealer-availability") === "True";
      dealerAvailabilityReact.removeAttribute("data-react-dealer-availability");
      let data = {
        mode : "dealer-availability",
        formElement : formElement,
        postcode : formElement.Postcode.value,
        dealerApiUrl : dealerAvailabilityReact.getAttribute("data-dealer-api-url"),
        postcodeElement : formElement.Postcode,
        placement: dealerAvailabilityReact.getAttribute("data-placement"),
        hasDealerAvailability: hasDealerAvailability
      }

      new DealerAvailabilityRenderer(dealerAvailabilityReact, data).render();
    }

    let detachedPostcodeInput = formElement.querySelector("[data-react-post-code-input]");
    if (detachedPostcodeInput) {
      detachedPostcodeInput.removeAttribute("data-react-post-code-input");
      let data = {
        mode : "post-code-input",
        formElement : formElement,
        postcodeElement : formElement.Postcode,
        placement : formElement.EnquiryLocation.value
      }

      new DealerAvailabilityRenderer(detachedPostcodeInput, data).render();
    }

    let carConnectReact = formElement.querySelector("[data-react-car-connect]");
    if (carConnectReact) {
      carConnectReact.removeAttribute("data-react-car-connect");
      let data = {
        mode : "car-connect",
        formElement : formElement,
        postcode : formElement.Postcode.value,
        postcodeElement : formElement.Postcode,
        suburbInfoUrl: carConnectReact.getAttribute("data-suburb-info-url"),
        placement : carConnectReact.getAttribute("data-placement")
      }

      new DealerAvailabilityRenderer(carConnectReact, data).render();
    }

    let enquiryFormWrappers = document.querySelectorAll(".enquiry-form");
    for (let i = 0; i < enquiryFormWrappers.length; i++) {
      enquiryFormWrappers[i].classList.remove("d-none");
    }
  }

  _initSearchQuery() {
    if(empty(this.formElement.SearchQuery)) return;
    let networkId = this.formElement.NetworkId.value;
    if (sessionStorage) {
      var lastSearch = sessionStorage.getItem(networkId);
      if (!empty(lastSearch) && lastSearch != "null") {
        this.formElement.SearchQuery.value = lastSearch;
      }
    }
  }

  _initEventListener() {
    this.eventBus.handle(EventName.EnquiryThankYouResponded, this._handleEnquirySubmittedEvent);
    this.eventBus.handle(EventName.EventTriggerFraudnetReject, this._handleEventTriggerFraudnetReject);
    this.eventBus.handle(EventName.FinanceEligibilityResponded, this._handleFinanceEligibilityResponded);
    this.eventBus.handle(EventName.GenericEnquiryFormError, this._handleGenericEnquiryFormError);
  }

  _handleSubmit(evt) {
    evt.preventDefault();

    if (!this.$form.valid())
      return false;

    if (this.formElement.SkipCollectingFraudnet.value.toUpperCase() !== "TRUE") {
      this._populateFraudNetInfo(evt.target);
    }
    
    this._populateTags(evt.target);
    this._sendEnquiry(evt.target);

    return false;
  }

  _populateFraudNetInfo(form) {
    if (typeof userdata === 'undefined' || typeof userdata.p_data !== 'function') {
      return;
    }

    userdata.p_data(form.FraudNetInfo.id);
  }

  _populateTags(form) {
    if (!sessionStorage) return;
    let tags = sessionStorage.getItem(form.NetworkId.value + "-tags");
    if (tags) {
      form.Tags.value = tags;
    }
  }

  _sendEnquiry(form) {
    let url = form.getAttribute("actionUrl");

    if (typeof csn !== "undefined" && csn.baseUrl) {
      url = csn.baseUrl + url;
    }

    let $form = $(form);
    let $this = this;
    let enquiryData = this._getEnquiryData($form);

    this.$errorMessageBox.text("");
    this._showLoading($form);
    $.ajax({
      url: url,
      type: "POST",
      data: $form.serialize(),
      dataType: "json",
      success: response => {
        if (!empty(response.userData)) {
          let userDataService = new UserDataService();
          userDataService.saveData(response.userData);
        }

        // fire tracking events
        $this.eventBus.dispatch(EventName.EnquirySentSuccess, {
          enquiryData: enquiryData,
          enquiryResponse: response
        });

        if (!empty(response.redirectUrl)) {
          // fire save car event
          $this.eventBus.dispatch(EventName.EnquirySaveCar, $this.formElement.NetworkId.value);
          window.location.href = response.redirectUrl;
          return;
        }

        $this._hideLoading($form);

        if (!empty(response.interStateConfirmation)) {
          $this._showInterstateConfirmationForm(response.interStateConfirmation);
          return;
        }
        
        this.body.animate({ scrollTop: this.$form.offset().top - 255 }, 300);

        $this.eventBus.dispatch(EventName.EnquirySaveCar, $this.formElement.NetworkId.value);

        if (!empty(response.thankYouHtml)) {
          // fire event to show thank you message on all enquiry forms
          $this.eventBus.dispatch(EventName.EnquiryThankYouResponded, response);
        }
      },
      error: errorDetail => {
        $this._showErrorSummary(errorDetail);
        $this._hideLoading($form);
      }
    });
  }

  _getEnquiryData($form) {
    let formDataArray = $form.serializeArray();
    let enquiryData = [];
    for (let i = 0; i < formDataArray.length; i++) {
      if (formDataArray[i].name in enquiryData) continue;
      enquiryData[formDataArray[i].name] = formDataArray[i].value;
    }
    return enquiryData;
  }

  _showLoading($form) {
    this.$submitButtons
      .addClass('loading')
      .prop("disabled", true);

  }

  _hideLoading($form) {
    this.$submitButtons
      .removeClass('loading')
      .prop("disabled", false);
  }

  _showErrorSummary(error) {
    let errorMessage = "";
    if (empty(error.responseJSON) || empty(error.responseJSON.errors)) {
      console.error(error);
      errorMessage = "Oops! Your enquiry has failed to send. <a href='javascript: window.location.reload()'>Click here</a> to refresh the page and try again.";
    }
    else {
      let errorMessageList = [];
      for (let i = 0; i < error.responseJSON.errors.length; i++) {
        errorMessageList.push(error.responseJSON.errors[i].message);
      }
      errorMessage = errorMessageList.join(", ");
    }

    this.$errorMessageBox
      .html(errorMessage)
      .show();
  }

  _showInterstateConfirmationForm(confirmationData) {
    this.$form.find(".proximity-message").text(confirmationData.proximityMessage);
    this.body.animate({ scrollTop: this.$form.offset().top - 255 }, 300);
    this.mainEnquiryForm.hide();
    this.interstateConfirmationForm.show();
  }

  _hideInterstateConfirmationForm() {
    this.mainEnquiryForm.show();
    this.interstateConfirmationForm.hide();
  }

  _handleEnquirySubmittedEvent(eventData) {
    let thankyouHtmlWrapper = null;
    if (!empty(eventData.thankYouHtml)) {
      thankyouHtmlWrapper =
        this.$form
          .children(".enquiry-form")
          .empty()
          .append(eventData.thankYouHtml);
      $(".postcode-panel-section").remove();
    }
    if (!empty(eventData.mediaMotiveHtml) 
        && !window.triggeredMediaMotiveAdPostEnquiry
        && thankyouHtmlWrapper) {
      window.triggeredMediaMotiveAdPostEnquiry = true;
      thankyouHtmlWrapper.append(eventData.mediaMotiveHtml);
    }
  }

  _handleEventTriggerFraudnetReject() {
    let form = this.formElement;
    if (sessionStorage) {
      let sessionKey = form.NetworkId.value + "-tags";
      let tags = sessionStorage.getItem(sessionKey);
      if (!/ViewNumber_Fraudnet_Reject/.test(tags)) {
        tags = tags
          ? tags + ",ViewNumber_Fraudnet_Reject"
          : "ViewNumber_Fraudnet_Reject";
        sessionStorage.setItem(sessionKey, tags);
      }
    }
    else {
      if (!/ViewNumber_Fraudnet_Reject/.test(form.Tags.value)) {
        form.Tags.value = form.Tags.value
          ? form.Tags.value + ",ViewNumber_Fraudnet_Reject"
          : "ViewNumber_Fraudnet_Reject";
      }
    }
  }

  _checkFinanceEligibility() {
    let stockId = this.formElement.NetworkId.value;
    onceOnly(() => {
      $("[check-finance-eligibility-url]", this.formElement).each(function () {
        let checkUrl = this.getAttribute("check-finance-eligibility-url");
        $.ajax({
          url : checkUrl+"?id="+stockId,
          success: function (result) {
            (new EventBus()).dispatch(EventName.FinanceEligibilityResponded, result)
          },
          error: function (error) {
            console.log(error);
          }
        });
      })
    }, 100, "CheckFinanceEligibilityViaAjax");
  }

  _handleFinanceEligibilityResponded(eventData) {
    if (eventData.isShowFinanceCheckbox) {
      let financeCheckboxSection = $("[check-finance-eligibility-url]", this.formElement);
      financeCheckboxSection.show();
      if (empty(eventData.tooltipContent)) {
        $("[tooltip-display]", financeCheckboxSection).hide();
        return;
      }

      $("[tooltip-display]", financeCheckboxSection).tooltip({
        title: eventData.tooltipContent
      });
    }

    if (eventData.dealerFinanceId !== null) {
      this.formElement.DealerFinanceId.value = eventData.dealerFinanceId;
      this.formElement.DealerFinanceVersion.value = eventData.dealerFinanceVersion;
    }
  }

  _handleGenericEnquiryFormError = (errorMessage) => {
    if (errorMessage) {
      this.$errorMessageBox
        .text(errorMessage)
        .show();
    }
    else {
      this.$errorMessageBox
        .text("")
        .hide();
    }
  }
}
